// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unactive[data-v-462be16c] {\n  color: #CACACA;\n}", ""]);
// Exports
module.exports = exports;
